import React from 'react';
// import HeroSection from '../components/HeroSection';
import WhyChooseUs from '../components/WhyChooseUs';
import Products from '../components/Products';
import TransXT from '../components/TransXT';
import Statistics from '../components/Statistics';
import Testimonials from '../components/Testimonials';
import Endorsements from '../components/Endorsements';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import TestHeroSection from '../components/TestHeroSection';

const Landing: React.FC = () => {
    return (
        <div>
            <TestHeroSection />
            {/* <HeroSection /> */}
            <WhyChooseUs />
            <Products />
            <TransXT />
            <Statistics />
            {/* <Testimonials /> */}
            <Endorsements />
            <ContactForm />
            <Footer />
        </div>
    );
};

export default Landing;
